export const analysisCrumbs = [
  {
    title: "Rent reporting",
    href: "/rent-reporting"
  },
  {
    title: "Upload CSV",
    href: "/rent-reporting/upload"
  },
  {
    title: "CSV file analysis",
    href: "/rent-reporting/upload/csv-analysis"
  }
];
